import { Component, OnInit } from '@angular/core';
import { ToastsManager } from 'ng2-toastr';
import { AdminService } from '../../_services/admin.service';
import { Log } from 'ng2-logger';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { ACLFeature } from '../../_models/acl-feature';
import {Tag} from '../../_models/tag';
import {AppService} from '../../app.service';
import {p} from '@angular/core/src/render3';
import {TagFamily} from '../../_models/tagFamily';

const log = Log.create('TagDetail');

@Component({
  moduleId: module.id,
  selector: 'edit-tag',
  styleUrls: ['tag.less'],
  templateUrl: 'tag.component.html',
})
export class TagComponent implements OnInit {
  tag: Tag = new Tag;
  tagFamily = new TagFamily;
  BASE_URL: string = environment.BASE_URL;

  readOnly: boolean = false;

  constructor(private route: ActivatedRoute,
              private router: Router,
              private admin: AdminService,
              private appService: AppService,
              private toast: ToastsManager) {}

  ngOnInit() {
    this.appService.headerData.path = [];
    // get sensor controller data
    this.route.params.subscribe(params => {
      if (params['id']) {
        this.admin.getTagController(params['id']).subscribe((response) => {
          this.tag = response;
          this.appService.headerData.title = this.tag.name;
          this.appService.tagBreadcrumbs.breadcrumbs = [{id: null, name: 'Label families'}, {id: this.tag.tagFamily.id, name: this.tag.tagFamily.name}];
          log.d('getSensorController response', response);
        });
      } else if (params['familyId']) {
        this.admin.getTagFamilyController(params['familyId']).subscribe((tagFamily) => {
          this.tag.tagFamily = tagFamily;
          this.tag.id = null;
          this.appService.headerData.title = 'New ' + tagFamily.name + ' label';
          this.appService.tagBreadcrumbs.breadcrumbs = [{id: null, name: 'Label families'}, {id: tagFamily.id, name: tagFamily.name}];
        });
      }
    });
  }

  private onCancel() {
    this.router.navigate(['/labels', { family: this.tag.tagFamily.id }]);
  }

  private onSubmit() {
    log.d('onSubmit fired');
    this.admin.postTagController(this.tag).subscribe((response) => {
      this.toast.success(`Changes have been saved.`);
      log.d('postTagController', 'post succesfull', response);

      this.router.navigate(['/labels', { family: this.tag.tagFamily.id, refresh: Date.now()}]);
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/tags-drilldown/tag/tag.component.ts